module.exports = __webpack_public_path__ + "media/images/rank/regular-md-034e72bb4180ef6f411d39d5fda71a99.svg";